import NumericAxis from '../axis/numeric';
import CategoryAxis from '../axis/category';
import { componentFactory, pluckNumber } from '../lib/lib';
/**
 * function to instatiate axis and get attached to canvas
 * @param {Object} chart chart API
 */
export default function (chart) {
  let children,
    chartAttr = chart.getFromEnv('chart-attrib'),
    showCumulativeLine = pluckNumber(chartAttr.showcumulativeline, 1),
    canvas = chart.getChildren('canvas')[0],
    axisRefVisualCartesian = canvas.getChildren('axisRefVisualCartesian')[0],
    zoomObj = {
      zoomable: true,
      pannable: true
    },
    config = chart._feedAxesRawData(),
    yAxes,
    xAxis,
    redraw = () => axisRefVisualCartesian.asyncDraw();

  componentFactory(chart, CategoryAxis, 'xAxis', 1, config.xAxisConf);
  children = chart.getChildren();
  xAxis = children.xAxis[0];

  axisRefVisualCartesian.setLinkedItem(xAxis.getId(), xAxis);
  canvas.attachAxis(xAxis, false, chart.zoomX ? zoomObj : {});
  xAxis.setLinkedItem('canvas', canvas);

  componentFactory(chart, NumericAxis, 'yAxis', showCumulativeLine ? 2 : 1, config.yAxisConf);
  yAxes = chart.getChildren('yAxis');

  yAxes && yAxes[1] && yAxes[1].setAxisConfig({
    isPercent: true,
    drawLabels: true,
    drawPlotLines: true,
    drawAxisName: true,
    drawAxisLine: true,
    drawPlotBands: true,
    drawTrendLines: true,
    drawTrendLabels: true
  });

  yAxes.forEach(axis => {
    if (axis.getState('removed') !== true) {
      axis.setLinkedItem('canvas', canvas);
      axisRefVisualCartesian.setLinkedItem(axis.getId(), axis);
      canvas.attachAxis(axis, true, chart.zoomY ? zoomObj : {});
      axisRefVisualCartesian.setLinkedItem(axis.getId(), axis);
      axisRefVisualCartesian.addExtEventListener('visiblerangeset', redraw, axis);
    } else {
      canvas.detachAxis(axis);
    }
  });
  chart._setCategories();
}
